(() => {
    "use strict";

    if (window.frBooksCatalog) {
        return;
    }


    // ==========================================================
    // SERVER CATALOG
    // ==========================================================

    const serverBookCatalogElement =
        document.getElementById(
            "fr-book-catalog"
        );


    const books = [];

    const booksBySlug =
        new Map();


    const chapters = [];

    const chaptersBySlug =
        new Map();


    // ==========================================================
    // HELPERS
    // ==========================================================

    function getBookDisplayTitle(
        title
    ) {
        return String(
            title ||
            ""
        )
            .replace(
                /^(?:FamBook|Book):\s*/i,
                ""
            )
            .trim();
    }


    function isFamilyBook(
        title
    ) {
        return /^FamBook:\s*/i.test(
            String(
                title ||
                ""
            )
        );
    }


    function isFamilyChapter(
        title
    ) {
        return /^FAM\s*-\s*/i.test(
            String(
                title ||
                ""
            )
        );
    }


    function createChapterRoute(
        bookSlug,
        chapterSlug
    ) {
        if (
            !bookSlug ||
            !chapterSlug
        ) {
            return "";
        }

        return (
            "/books/?book=" +
            encodeURIComponent(
                bookSlug
            ) +
            "&chapter=" +
            encodeURIComponent(
                chapterSlug
            )
        );
    }


    function createPresentationMetadata(
        book
    ) {
        const coverImage =
            String(
                book?.coverImage ||
                ""
            ).trim();

        return {
            title:
                getBookDisplayTitle(
                    book?.title ||
                    book?.tagName ||
                    ""
                ),

            subtitle:
                String(
                    book?.subtitle ||
                    ""
                ),

            author:
                "Tom Beaver",

            description:
                String(
                    book?.summary ||
                    ""
                ),

            status:
                "in-progress",

            coverImage,

            images: {
                primary:
                coverImage,

                thumbnail:
                coverImage,

                gallery:
                    coverImage
                        ? [
                            {
                                src:
                                coverImage,

                                caption:
                                    "Current cover"
                            }
                        ]
                        : []
            }
        };
    }


    // ==========================================================
    // ADD BOOK
    // ==========================================================

    function addBook(
        book
    ) {
        const slug =
            String(
                book?.slug ||
                ""
            ).trim();

        if (
            !slug ||
            booksBySlug.has(
                slug
            )
        ) {
            return null;
        }

        const normalizedBook = {
            id:
                String(
                    book?.id ||
                    ""
                ),

            slug,

            title:
                getBookDisplayTitle(
                    book?.title ||
                    book?.tagName ||
                    ""
                ),

            tagName:
                String(
                    book?.tagName ||
                    book?.title ||
                    ""
                ),

            description:
                String(
                    book?.description ||
                    ""
                ),

            featureImage:
                String(
                    book?.featureImage ||
                    ""
                ),

            coverImage:
                String(
                    book?.coverImage ||
                    ""
                ),

            isFamily:
                Boolean(
                    book?.isFamily
                ) ||
                isFamilyBook(
                    book?.tagName ||
                    ""
                ),

            catalogAccess:
                String(
                    book?.catalogAccess ||
                    ""
                ),

            type:
                String(
                    book?.type ||
                    ""
                ),

            subtitle:
                String(
                    book?.subtitle ||
                    ""
                ),

            estimatedPages:
                Number.isFinite(
                    Number(
                        book?.estimatedPages
                    )
                )
                    ? Number(
                        book.estimatedPages
                    )
                    : null,

            summary:
                String(
                    book?.summary ||
                    ""
                ),

            postCount:
                Number(
                    book?.postCount ||
                    0
                ),

            metadata:
                null,

            chapters:
                []
        };


        normalizedBook.metadata =
            createPresentationMetadata(
                normalizedBook
            );


        books.push(
            normalizedBook
        );


        booksBySlug.set(
            slug,
            normalizedBook
        );


        return normalizedBook;
    }


    // ==========================================================
    // ADD CHAPTER
    // ==========================================================

    function addChapter(
        book,
        chapterData
    ) {
        if (
            !book ||
            !chapterData
        ) {
            return null;
        }


        const slug =
            String(
                chapterData.slug ||
                ""
            ).trim();


        if (
            !slug ||
            chaptersBySlug.has(
                slug
            )
        ) {
            return null;
        }


        const title =
            String(
                chapterData.title ||
                ""
            );


        const chapter = {
            id:
                String(
                    chapterData.id ||
                    ""
                ),

            slug,

            title,

            url:
                String(
                    chapterData.url ||
                    ""
                ),

            guestReadable:
                chapterData.guestReadable ===
                true,

            isFamily:
                isFamilyChapter(
                    title
                ),

            book,

            route:
                createChapterRoute(
                    book.slug,
                    slug
                )
        };


        book.chapters.push(
            chapter
        );


        chapters.push(
            chapter
        );


        chaptersBySlug.set(
            slug,
            chapter
        );


        return chapter;
    }


    // ==========================================================
    // LOAD SERVER-FILTERED BOOKS
    //
    // generated-bookCatalog.hbs decides on the server which
    // books this viewer may discover.
    //
    // Books not emitted there never reach this JavaScript.
    // ==========================================================

    function loadServerBooks() {
        if (
            !serverBookCatalogElement
        ) {
            console.error(
                "Books catalog: #fr-book-catalog is missing."
            );

            return;
        }


        const chunks =
            serverBookCatalogElement
                .querySelectorAll(
                    "script[data-fr-book-catalog-chunk]"
                );


        chunks.forEach(
            (chunk) => {
                let records =
                    [];

                try {
                    records =
                        JSON.parse(
                            chunk.textContent ||
                            "[]"
                        );

                } catch (
                    error
                    ) {
                    console.error(
                        "Could not parse server book catalog chunk:",
                        error
                    );

                    return;
                }


                if (
                    !Array.isArray(
                        records
                    )
                ) {
                    return;
                }


                records.forEach(
                    (record) => {
                        addBook(
                            record
                        );
                    }
                );
            }
        );
    }


    // ==========================================================
    // LOAD VIEWER-FILTERED CHAPTERS
    //
    // frItemCatalog has already been restricted by Ghost access
    // before its records reach the browser.
    //
    // A chapter is attached only when its Book is also present
    // in this viewer's Book-discovery catalog.
    // ==========================================================

    function loadServerChapters() {
        const itemCatalog =
            window.frItemCatalog;


        if (
            !itemCatalog ||
            typeof itemCatalog.getItems !==
            "function"
        ) {
            console.warn(
                "Books catalog: frItemCatalog is unavailable."
            );

            return;
        }


        itemCatalog
            .getItems()
            .forEach(
                (item) => {
                    const bookSlug =
                        String(
                            item?.bookSlug ||
                            ""
                        ).trim();


                    if (
                        !bookSlug
                    ) {
                        return;
                    }


                    const book =
                        booksBySlug.get(
                            bookSlug
                        );


                    /*
                     * The item catalog may contain something
                     * whose Book is intentionally undiscoverable
                     * to this viewer. Do not manufacture a Book
                     * record from the item.
                     */
                    if (
                        !book
                    ) {
                        return;
                    }


                    addChapter(
                        book,
                        {
                            id:
                            item?.id,

                            slug:
                            item?.slug,

                            title:
                            item?.title,

                            url:
                            item?.url,

                            guestReadable:
                            item?.guestReadable
                        }
                    );
                }
            );
    }


    // ==========================================================
    // BUILD CATALOG
    // ==========================================================

    loadServerBooks();

    loadServerChapters();


    // ==========================================================
    // REMOVE SERVER-RENDERED GALLERY ENTRIES THAT THIS VIEWER
    // MAY NOT DISCOVER
    // ==========================================================

    document
        .querySelectorAll(
            ".fr-books-list-book"
        )
        .forEach(
            (bookElement) => {
                const bookSlug =
                    String(
                        bookElement.dataset
                            .bookSlug ||
                        ""
                    ).trim();


                if (
                    !booksBySlug.has(
                        bookSlug
                    )
                ) {
                    bookElement.remove();
                }
            }
        );


    // ==========================================================
    // READY
    // ==========================================================

    const ready =
        Promise.resolve(
            books
        );


    // ==========================================================
    // PUBLIC API
    // ==========================================================

    window.frBooksCatalog = {

        books,

        chapters,

        ready,


        getBooks() {
            return [
                ...books
            ];
        },


        getBook(
            slug
        ) {
            return (
                booksBySlug.get(
                    String(
                        slug ||
                        ""
                    ).trim()
                ) ||
                null
            );
        },


        getChapter(
            slug
        ) {
            return (
                chaptersBySlug.get(
                    String(
                        slug ||
                        ""
                    ).trim()
                ) ||
                null
            );
        },


        randomChapter() {
            if (
                !chapters.length
            ) {
                return null;
            }


            return chapters[
                Math.floor(
                    Math.random() *
                    chapters.length
                )
                ];
        },


        getChapterRoute(
            slug
        ) {
            const chapter =
                chaptersBySlug.get(
                    String(
                        slug ||
                        ""
                    ).trim()
                );


            return chapter
                ? chapter.route
                : null;
        },


        randomChapterRoute() {
            const chapter =
                this.randomChapter();


            return chapter
                ? chapter.route
                : null;
        }
    };


    console.log(
        "Books catalog:",
        books.length,
        "books,",
        chapters.length,
        "chapters",
        "| source: server-filtered only"
    );

})();
